import { InertiaApp } from '@inertiajs/inertia-vue';
import Vue from 'vue';

Vue.use(InertiaApp);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
VueCookies.config('7d');

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

import axios from 'axios';
Vue.prototype['$http'] = axios;

import VueToasted from "vue-toasted";
Vue.use(VueToasted,{duration: 6000, theme: 'bubble'});

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key:'AIzaSyBwFAr_j9eLn7zvBXqT6Emhdyd0QyDY2jA',
        mapTypeControl: false
    },
});

const Lang = require('lang.js');

import translations from './vue-translations.js';

const lang = new Lang({
    messages: translations,
    fallback: 'en'
});

// This is our normal Vue filter. '...args' allows us to use any
// number of parameters in our strings
Vue.filter('trans', (...args) => {
    return lang.get(...args);
});

export const EventBus = new Vue();
export const EventBusEventNames = {
    LmsFilterContactsDashboard : 'lms-filter-contacts-dashboard',
    LmsContactsDashboardUpdated: 'lms-contacts-dashboard-updated'
};
import Components from "./Components";
Vue.use(Components);

import Gadgets from "./Gadgets";
Vue.use(Gadgets);

import Icons from "./Icons";
Vue.use(Icons);

import GlobalMixins from "./Mixins/GlobalMixins";
Vue.mixin(GlobalMixins);

const app = document.getElementById('app');

new Vue({
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => import(`./Pages/${name}`).then(module => module.default)
        },
    }),
}).$mount(app);